require('../fhApp/currentUser/currentUser');

angular.module('app.changeEmail.changeEmailService', [
  'app.currentUser'
])
  .factory('app.changeEmail.changeEmailService', [
    '$http', 'currentUser',
    function ($http) {
      "use strict";
      return {
        confirmChange: (hash, old_email, current_password, new_email) => {
          return $http.put(window.location.api('sessions/change_email_confirmed'), {
            hash: hash,
            old_email: old_email,
            current_password: current_password,
            new_email: new_email
          });
        },
        getFromHash: (hash) => {
          return $http.get(window.location.api('sessions/change_email/' + hash));
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/changeEmail/changeEmailService.js